const DronePackageDelivery = require("./drone-package-delivery.gif");
const LoyaltyBonusCard = require("./loyalty-bonus-card.gif");
const FinancialPieChart = require("./financial-pie-chart.gif");
const SecureKeyLock = require("./secure-key-lock.gif");
const StartupLaunching = require("./startup-launching.gif");
const TarabutFaviconLoader = require("./tarabut-favicon-loader.gif");
const TarabutLoader = require("./tarabut.gif");
const GLFLDronePackageDelivery = require("./GLFL/drone-package-delivery.gif");
const GLFLLoyaltyBonusCard = require("./GLFL/loyalty-bonus-card.gif");
const GLFLRequestReminder = require("./GLFL/request-reminder.gif");
const GLFLSoftwareDevelopment = require("./GLFL/software-development.gif");
const FluencyOk = require("./fluency-ok.gif");
const EmailMarketing = require("./email-marketing.gif");

export {
  DronePackageDelivery,
  LoyaltyBonusCard,
  FinancialPieChart,
  SecureKeyLock,
  StartupLaunching,
  TarabutFaviconLoader,
  TarabutLoader,
  GLFLDronePackageDelivery,
  GLFLLoyaltyBonusCard,
  GLFLRequestReminder,
  GLFLSoftwareDevelopment,
  FluencyOk,
  EmailMarketing,
};
